import { render } from "./UsageTermsEn.vue?vue&type=template&id=4526bd9b&scoped=true"
import script from "./UsageTermsEn.vue?vue&type=script&lang=js"
export * from "./UsageTermsEn.vue?vue&type=script&lang=js"

import "./UsageTermsEn.vue?vue&type=style&index=0&id=4526bd9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4526bd9b"]])

export default __exports__